export const isEmpreendimentoVisibleOnSite = (mostrarSite: unknown): boolean => {
    if (mostrarSite === null || mostrarSite === undefined) {
        return true;
    }

    if (typeof mostrarSite === 'boolean') {
        return mostrarSite;
    }

    const normalized = String(mostrarSite).trim().toLowerCase();

    if (!normalized) {
        return true;
    }

    if (['false', '0', 'nao', 'não', 'off', 'no'].includes(normalized)) {
        return false;
    }

    if (['true', '1', 'sim', 'yes', 'on'].includes(normalized)) {
        return true;
    }

    const numeric = Number(normalized.replace(',', '.'));
    if (Number.isFinite(numeric)) {
        return numeric !== 0;
    }

    return true;
};
